import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

function hasRolloutAnnotation(entity: {
  metadata: { annotations?: Record<string, string> };
}): boolean {
  const a = entity.metadata.annotations ?? {};
  return Boolean(
    a['argoproj.io/rollout-stage-namespace'] ||
      a['argoproj.io/rollout-prod-namespace'] ||
      a['argoproj.io/rollout-namespace'],
  );
}

const argoRolloutsContent = EntityContentBlueprint.make({
  name: 'argo-rollouts',
  params: {
    path: '/argo-rollouts',
    title: 'Rollouts',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      hasRolloutAnnotation(entity),
    loader: () =>
      import('./ArgoRolloutsContent').then(m => <m.ArgoRolloutsContent />),
  },
});

export const argoRolloutsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [argoRolloutsContent],
});
